// Showing and Hiding of collapse elements in feature page
const collapseFeatureList = () => {
  const collapseBlocks = document.querySelectorAll('.feature-collapse-block');
  
  collapseBlocks.forEach((block) => {
    block.addEventListener('click', () => {
      // Helper function to find siblings with specific classes (replicating jQuery's .siblings() behavior)
      const findSiblingWithClass = (element, classNames) => {
        const parent = element.parentElement;
        if (!parent) {return null;}
        
        // Search through all children of the parent
        const siblings = Array.from(parent.children);
        return siblings.find((sibling) =>
          sibling !== element &&
          classNames.some((className) => sibling.classList.contains(className))
        );
      };
      
      // Find the collapse result sibling - look for siblings with collapse class or feature-collapse-result
      const collapseResult = findSiblingWithClass(block, ['collapse', 'feature-collapse-result']);
      
      // To prevent double click opening of accordion
      if (collapseResult && collapseResult.classList.contains('collapsing')) {
        return false;
      }
      
      if (collapseResult && collapseResult.classList.contains('show')) {
        block.classList.remove('collapse-opened');
        block.classList.add('collapse-closed');
        
        const nameSection = block.querySelector('.feature-sublist-name-section');
        const beforeCollapse = block.querySelector('.desc-box-before-collapse');
        const afterCollapse = block.querySelector('.desc-box-after-collapse');
        
        if (nameSection) {
          nameSection.classList.remove('collapse-hide-element');
          nameSection.classList.add('collapse-show-element');
        }
        if (beforeCollapse) {
          beforeCollapse.classList.remove('collapse-hide-element');
          beforeCollapse.classList.add('collapse-show-element');
        }
        if (afterCollapse) {
          afterCollapse.classList.add('collapse-hide-element');
          afterCollapse.classList.remove('collapse-show-element');
        }
      } else {
        block.classList.add('collapse-opened');
        block.classList.remove('collapse-closed');
        
        const nameSection = block.querySelector('.feature-sublist-name-section');
        const beforeCollapse = block.querySelector('.desc-box-before-collapse');
        const afterCollapse = block.querySelector('.desc-box-after-collapse');
        
        if (nameSection) {
          nameSection.classList.add('collapse-hide-element');
          nameSection.classList.remove('collapse-show-element');
        }
        if (beforeCollapse) {
          beforeCollapse.classList.add('collapse-hide-element');
          beforeCollapse.classList.remove('collapse-show-element');
        }
        if (afterCollapse) {
          afterCollapse.classList.remove('collapse-hide-element');
          afterCollapse.classList.add('collapse-show-element');
        }
      }
    });
  });
};

//Collapsibe card to hide and reveal card content
const collapsibleCard = () => {
  const sneakPeekSection = document.querySelector('.new-sneak-peek-collapse-section');
  const cardHeaders = document.querySelectorAll('.collapsible-card-header');
  
  cardHeaders.forEach((header) => {
    header.addEventListener('click', () => {
      const card = header.parentElement;
      
      // Expand on click
      card.classList.add('expanded');
      const collapseArrow = card.querySelector('.collapse-arrow');
      if (collapseArrow) {
        collapseArrow.classList.add('expanded');
      }

      if (sneakPeekSection) {
        const cardId = card.getAttribute('id');
        if (cardId) {
          // Show related content
          const relatedContent = document.querySelector(`.${cardId}`);
          if (relatedContent) {
            relatedContent.classList.remove('d-none');
            
            // Hide siblings
            const siblings = relatedContent.parentElement.children;
            Array.from(siblings).forEach((sibling) => {
              if (sibling !== relatedContent) {
                sibling.classList.add('d-none');
              }
            });
          }
          
          // Collapse other cards
          const parentCard = header.parentElement;
          const siblingCards = parentCard.parentElement.children;
          Array.from(siblingCards).forEach((sibling) => {
            if (sibling !== parentCard) {
              sibling.classList.remove('expanded');
              const siblingBody = sibling.querySelector('.collapsible-card-body');
              const siblingArrow = sibling.querySelector('.collapse-arrow');
              
              if (siblingBody) {
                siblingBody.classList.remove('show');
              }
              if (siblingArrow) {
                siblingArrow.classList.remove('expanded');
              }
            }
          });
        }
      }
    });
  });
};

// Collapsible card body in travel reimbursement page
const collapseCards = document.querySelectorAll('.collapse-card');
collapseCards.forEach((card) => {
  card.addEventListener('click', (event) => {
    // Remove collapse-open from all cards
    collapseCards.forEach((c) => c.classList.remove('collapse-open'));
    
    // Hide all mobile cards
    const mobileCards = document.querySelectorAll('.sneak-peek-mobile-card');
    mobileCards.forEach((mCard) => mCard.classList.add('d-none'));
    
    // Add collapse-open to clicked card
    event.currentTarget.classList.add('collapse-open');
    
    if (event.currentTarget.classList.contains('collapse-open')) {
      const mobileCard = event.currentTarget.querySelector('.sneak-peek-mobile-card');
      if (mobileCard) {
        mobileCard.classList.remove('d-none');
      }
    }
  });
});

// scroll top functionality (the arrow icon present in pricing page & all features page)
const scrollTopToggle = (scrollStartDiv, scrollEndDiv, scrollPaddingBottom = 0, scrollPaddingTop = 0) => {
  const scrollStartElement = document.querySelector(scrollStartDiv);
  const scrollEndElement = document.querySelector(scrollEndDiv);
  const scrollTopArrow = document.querySelector('.scroll-top-arrow');
  
  if (!scrollStartElement || !scrollEndElement || !scrollTopArrow) {
    return;
  }
  
  const scrollStartTop = scrollStartElement.getBoundingClientRect().top + window.pageYOffset;
  const scrollStartHeight = scrollStartElement.offsetHeight;
  const scrollEndTop = scrollEndElement.getBoundingClientRect().top + window.pageYOffset;
  const scrollEndHeight = scrollEndElement.offsetHeight;
  const windowHeight = window.innerHeight;
  const windowTop = window.pageYOffset;

  if (windowTop < (scrollEndTop + scrollEndHeight - windowHeight) - scrollPaddingBottom &&
    windowTop > (scrollStartTop + scrollStartHeight - windowHeight + scrollPaddingTop)) {
    scrollTopArrow.style.display = 'block';
    scrollTopArrow.style.opacity = '1';
  } else {
    scrollTopArrow.style.opacity = '0';
    setTimeout(() => {
      if (scrollTopArrow.style.opacity === '0') {
        scrollTopArrow.style.display = 'none';
      }
    }, 300);
  }
};

// Change section on hover in sneak-peek section
const sneakPeekSectionHover = () => {
  const navLinks = document.querySelectorAll('#software-sneak-peek-tabs .nav-link');
  
  navLinks.forEach((navLink) => {
    navLink.addEventListener('mouseenter', (event) => {
      // Remove active from all nav links
      const activeLinks = document.querySelectorAll('#software-sneak-peek-tabs .active');
      activeLinks.forEach((link) => link.classList.remove('active'));
      
      // Add active to current nav link
      event.currentTarget.classList.add('active');
      
      // Hide all tab panes
      const tabPanes = document.querySelectorAll('div.software-sneak-peek-tabContent div.tab-pane');
      tabPanes.forEach((pane) => {
        pane.classList.remove('show', 'active');
      });
      
      // Show target tab pane
      const href = event.currentTarget.getAttribute('href');
      if (href) {
        const targetPane = document.querySelector(href);
        if (targetPane) {
          targetPane.classList.add('show', 'active');
        }
      }
    });
  });
};

//Function to filter and remove duplicates items in the side navigation menu.
const getUniqueSideNavList = (sliderSection, allListItem) => {
  //Array to return filtered nav list.
  const uniqueSideNavList = [];
  //To keep track of index which is unique.
  let index = 0;
  //Looping through each slider section.
  sliderSection.forEach((section) => {
    //Getting number of list items in each slider section.
    const numOfList = section.querySelectorAll('li').length;
    const imgContainer = section.querySelectorAll('.slider-image-section-container');
    //Looping through each sub-sections inside slider section.
    imgContainer.forEach(() => {
      //Finding unique item and pushing into the list.
      uniqueSideNavList.push(allListItem[uniqueSideNavList.length + index]);
    });
    //Updating index for each slider section.
    index += numOfList;
  });
  return uniqueSideNavList;
};

export {
  collapseFeatureList,
  collapsibleCard,
  scrollTopToggle,
  sneakPeekSectionHover,
  getUniqueSideNavList,
};